import { string } from 'yup';

import { RelativePathModel } from '@/react/portainer/gitops/types';

import { getUnresolvedDynamicVariable } from './helmDynamicVariables';

export function resolvableValuesFileValidation(
  relativePath?: RelativePathModel
) {
  return string().test(
    'resolvable-dynamic-variable',
    function validateResolvableDynamicVariable(file) {
      if (!file) return true;

      const unresolvedVariable = getUnresolvedDynamicVariable(
        file,
        relativePath
      );
      if (!unresolvedVariable) return true;

      return this.createError({
        message: () =>
          `${unresolvedVariable} is not resolved by the current GitOps Edge configurations`,
      });
    }
  );
}
